import DownloadController from "csi/action/DownloadController";
import PostRequest from "csi/comm/PostRequest";
import { TableWidget } from "csi/table/Widget";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const ExportCanvasTemplatesController = declare(DownloadController, {

	/**
	 * @override
	 * Only continue with action if there are results in the table.
	 */
	process() {
		if ((this.widget as TableWidget).queryDisplayCount > 0) {
			return this.inherited(arguments);
		}
		this.displayErrorDialog({
			materialIcon: MessageDialog.ICON_ERROR,
			message: this.getString("_NoFilesToExport"),
			onResponse: () => {
				this.postProcess(true);
			},
			title: this.getString("_NoFilesToExportTitle"),
		});
	},

	/**
	 * @override
	 * Select files to upload.
	 */
	onDownloadRequest(request: PostRequest) {
		request.addParameter("TemplateCNLs", (this.widget as TableWidget).getMainQueryResultUrls());
	},
});

export = ExportCanvasTemplatesController;